const es = {
    APP_NAME: 'Consulta de Expedientes',
    HOME: 'Inicio',
    SELECT_CENTER: 'Selección de Centro Judicial',
    CANCEL: 'Cancelar',
    PLEASE_WAIT: 'Por favor aguarde',
    LOADING: 'Cargando',
    ACCEPT: 'Aceptar',
    CLOSE: 'Cerrar',
    LOGIN: 'Iniciar sesión',
    SEARCH_FORM: 'Buscador',
    LOAD_MORE: 'Cargar más',
    PROCEEDING: 'Expediente:',
    HISTORY: 'Historia',
    VIEW_FLIPBOOK: 'Ver en formato de libro',
    SIGNED: 'Firmado',
    VIEW_TEXT: 'Ver texto',
    VIEW_HISTORY: 'Ver historia',
    HISTORY_ATTACH: 'Adjuntos',
    HISTORY_LINK: 'Vínculos',
    NEW_SEARCH: 'Nueva búsqueda',
    PRINT: 'Imprimir',
    DOWNLOAD: 'Descargar',
    CLICK_TO_DOWNLOAD: 'Haga click para descargar',
    BACK: 'Volver atrás',
    NEW_VERSION: 'Nueva versión',
    MY_PROCEEDINGS: 'Mis Expedientes',
    REMOVE: 'Quitar',
    LIST: 'Listado',
    ADD_PROCEEDING: 'Agregar Expediente',
    OPEN_LINK: 'Abrir enlace',
    FIELDS: {
        EXPTE: 'No. Expt.',
        ACTOR: 'Actor',
        ACCUSED: 'Demandado',
        UNIT: 'Unidad Judicial',
        COVER: 'Carátula',
        PROCEEDING: 'Proceso',
        JURISDICTION: 'Fuero'
    },
    ERROR: {
        CAPTCHA: 'El captcha no se cargó correctamente, reintente por favor'
    }
};

export default es;